import styled from 'styled-components'

export const LoaderWrapper = styled.div`
  height: 30px;
  width: 30px;
`
